<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CrossTenantDelegationHistory')"
    width="600px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-inner-row" style="height:350px;padding:0">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <span slot="footer" style="padding:10px">
      <div style="float:right">
        <el-button type="primary" @click="exportExcel(columnDefs,rowData)">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>&nbsp;
        <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ColumnUtils from '@/utils/ColumnUtils'
import { CrossTenantHistory } from '@/class/model/booking/CrossTenantHistory'

export default {
  name: 'CrossTenantHistoryDialog',
  props: {
    visible: { type: Boolean, required: true },
    entrustmentType: { type: String, required: true },
    jobNo: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          colId: 'seqNo',
          field: 'seqNo',
          suppressMenu: true,
          width: 65
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'state',
          field: 'state',
          suppressMenu: true,
          width: 100,
          cellRenderer: params => {
            if (this.entrustmentType === '0') { // 委托方
              return ColumnUtils.crossTenantHisStateFunc(params.data, 'state', params.value)
            } else if (this.entrustmentType === '1') { // 接收方
              return ColumnUtils.crossTenantHisStateReceiverFunc(params.data, 'state', params.value)
            }
            return params.value
          }
        }, {
          headerName: this.$t('SeaExport.Operator'),
          colId: 'operatorName',
          field: 'operatorName',
          suppressMenu: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.OperationTime'),
          colId: 'operateDate',
          field: 'operateDate',
          suppressMenu: true,
          width: 140
        }, {
          headerName: this.$t('SeaExport.AdditionalInformation'),
          colId: 'remark',
          field: 'remark',
          suppressMenu: true,
          width: 110
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    async toQuery() {
      if (this.entrustmentType === '0') { // 发送方
        this.rowData = await CrossTenantHistory.queryHistoryFromSender(this.jobNo)
      } else if (this.entrustmentType === '1') { // 接收方
        this.rowData = await CrossTenantHistory.queryHistoryFromReceiver(this.jobNo)
      } else {
        this.rowData = []
      }
      for (let i = 0; i < this.rowData.length; ++i) {
        this.rowData[i].seqNo = i + 1
      }
    },
    exportExcel(columnDefs, rows) {
      const header = columnDefs.map(p => p.headerName)
      const data = rows.map(row => {
        row.seqNo = row.seqNo.toString()
        const arr = []
        for (const column of columnDefs) {
          const label = typeof column.cellRenderer === 'function'
            ? column.cellRenderer({ data: row, value: row[column.field] })
            : row[column.field]
          arr.push(label)
        }
        return arr
      })
      import('@/vendor/Export2Excel').then(excel => {
        excel.export_json_to_excel({
          header,
          data,
          filename: `${this.$t('SeaExport.DelegationStatusHistory')}${this.jobNo}_${moment().format('YYYYMMDDkkmmss')}`
        })
      })
    }
  }
}
</script>

<style>
</style>
